import { t } from "@/i18n-js/instance";
import { MemberCardWithConnection } from "@/react/components/shared/MembersList/CommunityMembers/CardView/MemberCardWithConnection";
import { ListView } from "@/react/components/shared/MembersList/CommunityMembers/ListView/ListView";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useRecommendations } from "@/react/hooks/recommendations/useRecommendations";
import { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";
import { EmptyRecommendations } from "../../Grow/components/Recommendations/EmptyRecommendations";
import { HorizontalListInfiniteScroll } from "../../shared/HorizontalListInfiniteScroll";

const activeConnectionsFilter = {
  id: "connections-active",
  key: "connections",
  status: "active",
};

const i18nBase = "members_directory.recommendations.empty_list";

export const MyConnections = () => {
  const allConnectionsQuery = useAudienceInfiniteQuery({
    filters: [activeConnectionsFilter],
    perPage: 10,
  });

  const hasNoConnections =
    allConnectionsQuery.audience.length === 0 && !allConnectionsQuery.isLoading;

  const {
    data: recommendations,
    isLoading: isLoadingRecommendations,
    isError: isErrorRecommendations,
  } = useRecommendations(hasNoConnections);

  const hasNoRecommendations =
    (recommendations?.length === 0 &&
      !isLoadingRecommendations &&
      !allConnectionsQuery.isLoading) ||
    isErrorRecommendations;

  const listviewParams = {
    ...allConnectionsQuery,
    dataLength: allConnectionsQuery.totalQueryAudience,
    totalMembers: allConnectionsQuery.totalAudience,
    members: allConnectionsQuery.audience,
    isActiveQuery: true,
  };

  if (allConnectionsQuery.isLoading || isLoadingRecommendations) {
    return <Loader />;
  }

  if (hasNoConnections) {
    if (hasNoRecommendations) {
      return <EmptyRecommendations />;
    }

    return (
      <div className="m-auto mx-2 mt-6 flex flex-col justify-center gap-y-2 text-center">
        <div className="flex flex-col justify-center gap-y-2 text-center">
          <Typography.TitleLg weight="bold" color="text-primary">
            {t(`${i18nBase}.build_connection_header`)}
          </Typography.TitleLg>
          <Typography.BodySm>
            {t(`${i18nBase}.build_connection_description`)}
          </Typography.BodySm>
        </div>
        <HorizontalListInfiniteScroll
          totalCount={recommendations?.length ?? 0}
          title=""
          items={
            recommendations?.map(
              recommendation => recommendation.target_community_member,
            ) ?? []
          }
          hasMore={false}
          fetchNextPage={() => Promise.resolve()}
          isFetchingNextPage={Boolean(isLoadingRecommendations)}
          isLoading={Boolean(isLoadingRecommendations)}
          containerClassName="mt-6"
          listClassName="mb-6 flex list-none flex-row gap-3 pr-4"
          renderItem={person => (
            <MemberCardWithConnection member={person} key={person.id} />
          )}
        />
      </div>
    );
  }

  return (
    <ListView
      memberDataParams={listviewParams}
      shouldShowHiddenMemberTooltip={false}
      shouldShowConnectionStatus={false}
    />
  );
};
